import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RelayTransactionDetailComponent } from "./relay-transaction-detail/relay-transaction-detail.component";

const routes: Routes = [
  {
		path: "",
		component: RelayTransactionDetailComponent,
	},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelayTransactionDetailRoutingModule { }
